'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mix = function (from, to, progress) {
  return -progress * from + progress * to + from;
};

exports.mix = mix;
